import { render, staticRenderFns } from "./userProfileEntityDataWorkflows.vue?vue&type=template&id=4c3a5d7c&scoped=true"
import script from "./userProfileEntityDataWorkflows.vue?vue&type=script&lang=js"
export * from "./userProfileEntityDataWorkflows.vue?vue&type=script&lang=js"
import style0 from "./userProfileEntityDataWorkflows.vue?vue&type=style&index=0&id=4c3a5d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3a5d7c",
  null
  
)

export default component.exports